import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { OuterMeasurementsComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
/**
 * Add OuterMeasurementsComponent to front if it's not placed on loft bed and remove it if
 * it is placed on loft bed
 */
export class FrontMeasurementsSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'FrontMeasurementsSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity, newComponent) {
        const doorOrDrawer = this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.SMASTAD_HINGE_DOOR_ASM,
            ProductType.SMASTAD_DRAWER_ASM
        ]);
        const front = doorOrDrawer
            ? HierarchyUtils.descendants(entity).find(child => this.coreApi.entities.isOneOfProductTypes(child, [
                ProductType.SMASTAD_DOOR_FRONT,
                ProductType.SMASTAD_DRAWER_FRONT
            ]))
            : undefined;
        if (!front)
            return;
        const hostIsLoftBed = this.placedOnLoftBed(newComponent.snap.host);
        if (hostIsLoftBed) {
            // Front added to loft bed. Remove OuterMeasurementsComponent
            if (front.hasComponent(OuterMeasurementsComponent.id)) {
                front.removeComponent(OuterMeasurementsComponent.id);
            }
        }
        else if (!hostIsLoftBed) {
            // Front added to other frame than loft bed. Add OuterMeasurementsComponent
            if (!front.hasComponent(OuterMeasurementsComponent.id)) {
                front.addComponent(new OuterMeasurementsComponent());
            }
        }
    }
    onUpdate() { }
    onRemove() { }
    placedOnLoftBed(host) {
        return (host
            .getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)
            ?.templateId.includes('loft-bed') ?? false);
    }
}
//# sourceMappingURL=FrontMeasurementsSystem.js.map